import Logger from '../lib/logger';
import { getCardData, handlize, money } from '../lib/util.functions';

class ProductCard extends HTMLElement {
  #NAME ='ProductCard'
  #variantId

  constructor() {
    super();
    this.productBtn = this.querySelector('label.theme-button');
    this.productBtnInput = this.productBtn.querySelector('input');
    this.numberBtn = this.querySelector('number-button');
    this.priceEL = this.querySelector('[data-price]');
    this.variantIdEls = this.querySelectorAll('[data-product-variant]');
    this.template = this.querySelector('template');
    this.templateForm = this.template?.content.querySelector('form');
    this.templateBtnInput = this.template?.content.querySelector('label[data-product-btn] input');
    this.templatePrice = this.template?.content.querySelector('[data-price]');
    this.img = this.querySelector('img');
    this.content = this.querySelector('.bundler-grid__items__grid-item__content');
  }

  connectedCallback() {
    if (this.numberBtn) {
      this.numberBtn.input.addEventListener('input', (e) => {
        if (e.target.valueAsNumber === 0) {
          this.#dispatchBundleStepEvent(getCardData(this, 'remove', { quantity: 0 }));
        } else {
          this.#dispatchBundleStepEvent(getCardData(this, 'update', { quantity: parseInt(e.target.value) }));
        }
      });
    }
    //
    this.productBtnInput.addEventListener('change', () => {
      if (this.productBtnInput.checked) {
        this.otherRadios();
        let quantity = 1
        if (this.productBtnInput.type === 'checkbox' && this.dataset.minQuantity && this.dataset.minQuantity != quantity) quantity = parseInt(this.dataset.minQuantity);
        this.#dispatchBundleStepEvent(getCardData(this, 'add', { quantity }), this.productBtnInput.type === 'radio');
      } else {
        this.#dispatchBundleStepEvent(getCardData(this, 'remove', { quantity: 0 }));
      }
    });
  }

  static get observedAttributes() {
    return ['data-variant-id', 'data-quantity', 'data-options', 'data-product-price', 'data-min-quantity', 'data-num-allowed'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    /* Logger.info(`${this.#NAME}: ${this.dataset.productTitle} > attributeChangedCallback`, name, oldValue, newValue); */
    if (oldValue !== newValue) {
      switch (name) {
        case 'data-variant-id':
          this.#variantId = newValue;
          this.variantIdEls.forEach(el => el.dataset.productVariant = this.#variantId);
          this.productBtnInput.value = this.#variantId;
          break;
        
        case 'data-min-quantity':
          if (this.templateBtnInput.type === 'radio') {
            if (!this.minQuantityInput) {
              this.minQuantityInput = document.createElement('INPUT');
              this.minQuantityInput.hidden = true;
              this.minQuantityInput.required = true;
              this.minQuantityInput.type = 'checkbox';
              this.minQuantityInput.name = 'min-quantity-met';
              this.appendChild(this.minQuantityInput);
            }
            this.minQuantityInput.dataset.min = newValue;
          }
          break;

        case 'data-num-allowed':
          this.dataset.maxAdded = newValue === this.dataset.quantity;
          if (this.dataset.maxAdded === 'true') this.templateForm?.setAttribute('disabled', 'true');
          break;

        case 'data-quantity':
          Logger.info(`${this.#NAME}: ${this.dataset.productTitle} ${this.dataset.groupIndex} > attributeChangedCallback`, name, oldValue, newValue);
          if (newValue !== '0') {
            if (this.numberBtn) {
              this.numberBtn.dataset.value = newValue;
              this.template.content.querySelector('number-button input')?.setAttribute('value', newValue);
            }
            this.template?.content.querySelector('label[data-product-btn] input')?.setAttribute('checked', true);
            this.productBtnInput.checked = true; /* console.log('set true'); */
            //
            const updaters = this.querySelectorAll('variant-updater');
            if (updaters.length) {
              const max = parseInt(this.dataset.numAllowed) - parseInt(newValue);
              updaters.forEach(el => el.dataset.max = max + el.quantity);
              if (!max) {
                this.templateForm?.setAttribute('disabled', true);
              } else {
                this.templateForm?.removeAttribute('disabled');
              }
              this.dataset.maxAdded = !max;
            }
            //
          } else {
            this.productBtnInput.checked = false; /* console.log('set false') */
            this.template?.content.querySelector('label[data-product-btn] input')?.removeAttribute('checked');
            this.dataset.options = '';
            this.querySelectorAll('variant-updater').forEach(el => el.remove());
          }
          //
          if (this.minQuantityInput) {
            this.minQuantityInput.checked = this.minQuantityInput.dataset.min === newValue;
          }
          break;

        case 'data-options':
          /* console.log('ProductCard data-options newValue', newValue, this.dataset.selectMultiple, this.dataset.quantity); */
          if (newValue && newValue !== '') {
            const arr = newValue.split('|');
            const names = arr[0].split(',');
            const values = arr[1].split(',');
            //
            this.templateForm?.querySelectorAll('input[checked]')?.forEach(el => el.removeAttribute('checked'));
            //
            names.forEach((name, i) => {
              const value = values[i];
              const input = this.templateForm?.querySelector(`input[name="${handlize(name)}"][data-value-handle="${handlize(value)}"]`);
              /* console.log(handlize(name), encodeURI(value), input); */
              input?.setAttribute('checked', 'true');
            });
            this.templateBtnInput.setAttribute('checked', 'true');
          } else {
            this.templateForm?.querySelectorAll('input[checked]')?.forEach(el => el.removeAttribute('checked'));
          }
          break;

        case 'data-product-price':
          const price = money(newValue);
          /* if (this.priceEL) this.priceEL.textContent = price; */
          if (this.templatePrice) this.templatePrice.textContent = price;
          break;

        case 'data-product-image':
          if(this.img) this.img.src = newValue;
          break;
      
        default:
          break;
      }
    }
  }

  otherRadios() {
    if (this.productBtnInput.type === 'radio') {
      let otherCards = this.parentElement.querySelectorAll(`product-card:has(input[name="${this.productBtnInput.name}"]:not([id="${this.productBtnInput.id}"]))`);
      otherCards.forEach(card => {
        if (card.dataset.quantity != '0'){
          card.dataset.options = '';
          if (card.dataset.selectMultiple === 'true') {
            card.querySelectorAll('variant-updater').forEach(el => {
              this.#dispatchBundleStepEvent({ name: 'remove', data: { quantity: 0, variantId: el.dataset.variantId } });
              el.remove();
            });
          } else {
            this.#dispatchBundleStepEvent(getCardData(card, 'remove', { quantity: 0 }));
          }
        }
      });
    }
  }

  #dispatchBundleStepEvent(detail, replace = false) {
    const event = new CustomEvent('bundlestep:event', {
      detail: {...detail, replace},
      bubbles: true
    });
    this.dispatchEvent(event);
  }
}

customElements.define('product-card', ProductCard);